export const customStyles = () => ({
  control: (provided) => ({
    ...provided,
    width: 78,
    transition: 'width 0.3s ease',
  }),
  menu: (provided) => ({
    ...provided,
    width: 250,
  }),
});


export const customStylesCliente = () => ({
  control: (provided) => ({
    ...provided,
    width: 78,
    transition: 'width 0.3s ease',
    backgroundColor: '#2b2b2b', // gris oscuro
    color: '#fff',
    fontWeight: 'bold',
    borderColor: '#555',
  }),
  menu: (provided) => ({
    ...provided,
    width: 250,
    backgroundColor: '#2b2b2b',
    color: '#fff',
    fontWeight: 'bold',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#3a3a3a' : '#2b2b2b',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
    fontWeight: 'bold',
  }),
  input: (provided) => ({
    ...provided,
    color: '#fff',
    fontWeight: 'bold',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ccc',
    fontWeight: 'bold',
  }),
});